import React, { useState } from "react";
import { Grid, Paper,Button, Select, MenuItem, InputLabel, FormControl, Typography, useMediaQuery} from "@mui/material";
import { ArrowDropDown, Settings } from "@mui/icons-material";
import Input from "../../../components/common/input/Input";

const ReportTab = () => {
    const [isBankLinked,setIsBankLinked] = useState([]);
    const [settings,setSettings] = useState(false);
        const isLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));

    return(
        <Grid container spacing={2} style={{ padding: '0px !important' }} className="max-h-[calc(100vh-210px)] overflow-y-auto">
            <Grid item xs={12} lg={4}>
                <Paper elevation={3} className="p-5 relative">
                    <div className="flex justify-end mb-2">
                        <p className="flex items-center gap-2 font-semibold cursor-pointer" onClick={() => setSettings(true)}>
                            Financial Settings
                            <Settings color="primary" fontSize="small"/>
                        </p>
                    </div>
                    {isBankLinked.length > 0 ? 
                      <div>
                        <label className="font-medium text-gray-800 block mb-2">Linked bank accounts</label>
                      </div>
                      : 
                      <div className="mt-5">
                        <Button variant="contained" color="primary" disableElevation>Link Your Bank Account</Button>
                      </div> 
                    }
                </Paper>
            </Grid>

            <Grid item xs={12} lg={8} className="h-full">
                <Paper elevation={3} className="p-5 relative">
                    <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">Generate Reports</Typography>
                   <Grid container spacing={2} className="!mt-5">
                        <Grid item xs={12} md={6} lg={4}>
                            <FormControl fullWidth>
                                <InputLabel
                                    style={{
                                        lineHeight: '16px', 
                                        marginTop: -4, 
                                    }}
                                >
                                    Select Report Type
                                </InputLabel>
                                <Select
                                IconComponent={(props) => <ArrowDropDown {...props} style={{ color: "#c942b1" }} />}
                                style={{ height: '40px' }}
                                label="Select Report Type"
                                >
                                    <MenuItem>PDF</MenuItem>
                                    <MenuItem>XLS</MenuItem>
                                    <MenuItem>DOCS</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <FormControl fullWidth>
                                <InputLabel
                                    style={{
                                        lineHeight: '16px', 
                                        marginTop: -4, 
                                    }}
                                >
                                    Select Format
                                </InputLabel>
                                <Select
                                IconComponent={(props) => <ArrowDropDown {...props} style={{ color: "#c942b1" }} />}
                                style={{ height: '40px' }}
                                label="Select Report Type"
                                >
                                    <MenuItem>PDF</MenuItem>
                                    <MenuItem>XLS</MenuItem>
                                    <MenuItem>DOCS</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <Input type="date" label="Select date range" />
                        </Grid>
                   </Grid>
                   <Button variant="contained" color="primary" disableElevation className="!mt-10 !w-fit !px-4">
                    Generate Report
                   </Button>
                </Paper>
            </Grid>
            {(isLgScreen && settings) && (
                <div className="fixed hidden lg:flex bg-gray-800 bg-opacity-40 w-full h-full top-0 left-0 justify-end z-10">
                    <div className="bg-white w-2/4 flex flex-col p-5 mt-16 gap-5 overflow-y-auto">
                        <div className="flex justify-between w-full">
                            <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">Financial Settings</Typography>
                            <div className="p-1.5 rounded-full bg-primary h-fit text-white cursor-pointer" onClick={() => setSettings(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-6" className="h-4 w-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                            </div>
                        </div>
                        <div>
                        <label className="mb-5 font-semibold">Alert Preferences</label>
                        <FormControl fullWidth className="!my-2">
                                {/* <InputLabel>Select alert preferences</InputLabel> */}
                                <Select
                                    // label="Select from friend list"
                                    IconComponent={(props) => (
                                        <ArrowDropDown {...props} style={{ color: "#c942b1" }} /> 
                                    )}
                                >
                                    <MenuItem value="">None</MenuItem>
                                    <MenuItem value="Electronic">Alert Type 1</MenuItem>
                                    <MenuItem value="Mobile">Alert Type 2</MenuItem>
                                    <MenuItem value="Laptop">Alert Type 3</MenuItem>
                                </Select>
                        </FormControl>
                        </div>
                        <div>
                        <label className="mb-5 font-semibold">Currency Type</label>
                        <FormControl fullWidth className="!my-2">
                                {/* <InputLabel>Select currency type</InputLabel> */}
                                <Select
                                    // label="Select from friend list"
                                    IconComponent={(props) => (
                                        <ArrowDropDown {...props} style={{ color: "#c942b1" }} /> 
                                    )}
                                >
                                    <MenuItem value="">None</MenuItem>
                                    <MenuItem value="Electronic">Currency Type 1</MenuItem>
                                    <MenuItem value="Mobile">Currency Type 2</MenuItem>
                                    <MenuItem value="Laptop">Currency Type 3</MenuItem>
                                </Select>
                        </FormControl>
                        </div>
                        <Button className="mt-10" variant="contained" color="primary">Save Changes</Button>
                    </div>
                </div>
            )}
            {(!isLgScreen && settings) && (
                <div className="fixed lg:hidden bg-gray-800 bg-opacity-40 w-full h-full top-0 left-0 flex flex-col z-10">
                    <div className="bg-white flex flex-col p-5 gap-5 flex-1 mt-28 overflow-y-auto rounded-tl-xl rounded-tr-xl">
                        <div className="flex justify-between w-full">
                            <Typography variant="subtitle1" color="textPrimary" className="!font-semibold">Financial Settings</Typography>
                            <div className="p-1.5 rounded-full bg-primary h-fit text-white cursor-pointer" onClick={() => setSettings(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-6" className="h-4 w-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                            </div>
                        </div>
                        <div>
                        <label className="mb-5 font-semibold">Alert Preferences</label>
                        <FormControl fullWidth className="!my-2">
                                {/* <InputLabel>Select alert preferences</InputLabel> */}
                                <Select
                                    // label="Select from friend list"
                                    IconComponent={(props) => (
                                        <ArrowDropDown {...props} style={{ color: "#c942b1" }} /> 
                                    )}
                                >
                                    <MenuItem value="">None</MenuItem>
                                    <MenuItem value="Electronic">Alert Type 1</MenuItem>
                                    <MenuItem value="Mobile">Alert Type 2</MenuItem>
                                    <MenuItem value="Laptop">Alert Type 3</MenuItem>
                                </Select>
                        </FormControl>
                        </div>
                        <div>
                        <label className="mb-5 font-semibold">Currency Type</label>
                        <FormControl fullWidth className="!my-2">
                                {/* <InputLabel>Select currency type</InputLabel> */}
                                <Select
                                    // label="Select from friend list"
                                    IconComponent={(props) => (
                                        <ArrowDropDown {...props} style={{ color: "#c942b1" }} /> 
                                    )}
                                >
                                    <MenuItem value="">None</MenuItem>
                                    <MenuItem value="Electronic">Currency Type 1</MenuItem>
                                    <MenuItem value="Mobile">Currency Type 2</MenuItem>
                                    <MenuItem value="Laptop">Currency Type 3</MenuItem>
                                </Select>
                        </FormControl>
                        </div>
                        <Button className="mt-10" variant="contained" color="primary">Save Changes</Button>
                    </div>
                </div>
            )}
        </Grid>
    )
}

export default ReportTab;